import React, { useEffect } from "react";

interface Props {
  onComplete?: (changedValue: string) => void;
  maxLength?: number;
}

export default function TagInput(props: Props) {
  const { maxLength, onComplete } = props;
  const tagInputRef = React.createRef<any>();

  const handleSubmitText = () => {
    const tagText = tagInputRef.current.value;
    onComplete?.(tagText);
  };

  useEffect(() => {
    if (tagInputRef.current) {
      tagInputRef.current.focus();
    }
  }, [tagInputRef]);

  return (
    <input
      className="ml-2 w-24 h-6 border-1.5 border-silver outline-none rounded-lg p-0.5 inline-block"
      ref={tagInputRef}
      onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter") {
          handleSubmitText();
        }
      }}
      onBlur={handleSubmitText}
      name="tagText"
      maxLength={maxLength}
    />
  );
}
